import { createTheme } from "@mui/material";
import type {} from "@mui/material/themeCssVarsAugmentation"; // https://mui.com/material-ui/customization/css-theme-variables/usage/#typescript
import { dark } from "./dark";
import { light } from "./light";

export const theme = createTheme({
  colorSchemes: {
    dark: dark(),
    light: light(),
  },
  cssVariables: {
    colorSchemeSelector: "data-color-scheme",
    nativeColor: true,
  },
});
